<template>
  <div ref="queryForm">
    <el-form
      ref="forms"
      :class="More ? 'glo_form hasMoreParam' : 'glo_form'"
      label-position="left"
    >
      <span v-for="(item, index) in F_config" :key="index">
        <el-form-item
          class="queryItems"
          v-if="item.textBoxType === 'input'"
          :label="item.conditonKeyShow"
        >
          <!-- v-model="F_Data[item.conditonKey]" -->
          <el-input
            v-model="item.conditonVal"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          v-if="item.textBoxType === 'select'"
          :label="item.conditonKeyShow"
        >
          <!-- v-model="F_Data[item.conditonKey]" -->
          <el-select
            v-model="item.conditonVal"
            clearable
            remote
            filterable
            :remote-method="
              (e) => {
                remoteMethod(e, item, index);
              }
            "
            @focus="
              (e) => {
                focusMethod(item, index);
              }
            "
            @clear="remoteMethod('', item, index)"
          >
            <el-option
              v-for="(option, num) in item.selectOptions"
              :label="option[item.dropdownShowField]"
              :value="option[item.dropdownSubmitField]"
              :key="num"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItemsTimes"
          v-if="item.textBoxType === 'datetime'"
        >
          <multitime
            :timeType="item.timeType"
            :timeTypes="item.timeTypes"
            :startTime="item.startTime_a"
            :endTime="item.endTime_a"
            @timestatus="
              (type, s, e) => {
                timestatus(type, s, e, index);
              }
            "
            @queryBtn_ok="
              (s, e) => {
                queryBtn_time(s, e, index);
              }
            "
          ></multitime>
        </el-form-item>
      </span>
    </el-form>
  </div>
</template>
<script>
import multitime from "@/components/multiTime.vue";
export default {
  components: { multitime },
  props: {
    formConfig: {
      type: Array,
    },
    formData: {
      type: Object,
    },
    More: {
      type: Boolean,
    },
  },
  emits: ["changeCallback", "EnterClick"],
  data() {
    return {
      F_config: this.formConfig,
      F_Data: this.formData,
    };
  },
  watch: {
    formConfig: {
      handler(newValue, oldValue) {
        this.F_config = newValue;
      },
      deep: true, // 默认值是 false，代表是否深度监听
    },
  },
  methods: {
    // 时间组件 选择时间后触发
    queryBtn_time(s, e, index) {
      // this.F_config[index].startTime_a = `${s} 00:00:00` || "";
      // this.F_config[index].endTime_a = `${e} 23:59:59` || "";
      this.F_config[index].startTime_a = s || "";
      this.F_config[index].endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e, index) {
      this.F_config[index].timeType = type || "";
      // this.F_config[index].startTime_a = `${s} 00:00:00` || "";
      // this.F_config[index].endTime_a = `${e} 23:59:59` || "";
      this.F_config[index].startTime_a = s || "";
      this.F_config[index].endTime_a = e || "";
    },
    async focusMethod(item, index) {
      if (this.F_config[index].selectOptions.length == 0) {
        await this.$API
          .runPageReport({
            conditionReqs: [
              {
                conditonKey: item.dropdownShowField,
                conditonVal: "",
              },
            ],
            number: item.dropdownApiNumber,
            pageStart: 1,
            pageTotal: 20,
          })
          .then((res) => {
            let datas = res.data.result.datas.data || [];
            this.F_config[index].selectOptions = datas;
          });
      }
    },
    // 远程搜索
    async remoteMethod(e, item, index) {
      await this.$API
        .runPageReport({
          conditionReqs: [
            {
              conditonKey: item.dropdownShowField,
              conditonVal: e,
            },
          ],
          number: item.dropdownApiNumber,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let datas = res.data.result.datas.data || [];
          this.F_config[index].selectOptions = datas;
        });
      this.$emit("changeCallback", e, name);
    },
    // 滚动条加载更多
    loadmore(e) {
      this.$emit("changeCallback", "", e);
    },
    enterClick() {
      this.$emit("EnterClick");
    },
  },
};
</script>
<style lang="less">
</style>
